import React, { ReactNode } from 'react';

export interface Props {
  children?: ReactNode;
}

export const ButtonGroup = ({ children }: Props) => (
  <div className="button-group">{children}</div>
);
